<template>
    <veui-dialog
        title="提示"
        :open="open"
        overlay-class="pay-overlay"
        @cancel="handleCancel"
    >
        <div class="pay-content">
            <div class="pay-content-left">
                <veui-icon
                    class="pay-content-icon"
                    name="exclamation-circle"
                />
            </div>
            <div class="pay-content-right">请您在新打开的页面完成支付！<br>支付完成前请不要关闭此窗口。</div>
        </div>
        <template #foot>
            <veui-button
                ui="primary"
                class="ok-btn"
                @click="handleFinish"
            >
                支付完成
            </veui-button>
            <veui-button
                ui="warning"
                class="retry-btn"
                @click="handleRetry"
            >
                支付失败，继续支付
            </veui-button>
        </template>
    </veui-dialog>
</template>

<script>
import {Dialog, Button, Icon} from 'veui';

import 'veui-theme-dls-icons/exclamation-circle';

export default {
    components: {
        'veui-dialog': Dialog,
        'veui-button': Button,
        'veui-icon': Icon
    },
    props: {
        open: Boolean
    },
    methods: {
        handleCancel() {
            this.$emit('cancel');
        },
        handleFinish() {
            this.$emit('finish');
        },
        handleRetry() {
            this.$emit('retry');
        }
    }
};
</script>

<style lang="less" scoped>
    .pay-overlay {
        --dls-dialog-width: 500px;
        /deep/ .veui-dialog-content-body {
            max-height: 500px;
        }
        /deep/ .veui-dialog-content-foot {
            display: flex;
            align-items: center;
            justify-content: center;
        }
        .pay-content {
            display: flex;
            align-items: center;
            justify-content: center;
            &-left {
                margin-right: 30px;
                .pay-content-icon {
                    font-size: 50px;
                    color: orange;
                }
            }
            &-right {
                text-align: left;
            }
        }
        p {
            text-indent: 2em;
        }
        .ok-btn {
            border-radius: 4px;
            background: #3A5BFD;
            margin-right: 30px;
        }
        .retry-btn {
            background: orange;
            color: #fff;
        }
    }
</style>
